import React from 'react';
import { motion } from 'framer-motion';
import starMicroinsurance from '../../../assets/images/home/star-microinsurance.webp';
import rabito from '../../../assets/images/home/rabito.webp';
import nic from '../../../assets/images/home/nic.webp';
import mtn from '../../../assets/images/home/mtn.webp';

const partners = [
  {
    name: 'Star Microinsurance',
    logo: starMicroinsurance,
    description: 'Leading microinsurance provider'
  },
  {
    name: 'Rabito',
    logo: rabito,
    description: 'Healthcare financing partner'
  },
  {
    name: 'NIC Insurance',
    logo: nic,
    description: 'Insurance solutions provider'
  },
  {
    name: 'MTN',
    logo: mtn,
    description: 'Mobile money services'
  }
];

// Repeat partners 3x to ensure smooth looping
const loopedPartners = [...partners, ...partners, ...partners];

export default function Partners() {
  return (
    <section className="py-10 overflow-hidden bg-gray-50 sm:py-32">
      <div className="px-6 mx-auto max-w-7xl lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Our Trusted Partners
          </h2>
        </div>

        <div className="relative mt-16">
          {/* Gradient overlays */}
          <div className="absolute left-0 z-10 w-32 h-full bg-gradient-to-r from-gray-50 to-transparent"></div>
          <div className="absolute right-0 z-10 w-32 h-full bg-gradient-to-l from-gray-50 to-transparent"></div>

          {/* Infinite slider */}
          <div className="overflow-hidden">
            <motion.div
              className="flex gap-8"
              animate={{ x: ['0%', '-100%'] }}
              transition={{
                duration: 40, // Slower and smoother
                ease: 'linear',
                repeat: Infinity,
              }}
            >
              {loopedPartners.map((partner, idx) => (
                <div
                  key={`${partner.name}-${idx}`}
                  className="flex-shrink-0 w-48 px-4 transition-transform duration-300 transform hover:scale-105"
                >
                  {/* <div className="relative flex items-center justify-center"> */}
                    <img
                      className="object-contain w-full h-full"
                      src={partner.logo}
                      alt={partner.name}
                    />
                  {/* </div> */}
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
